import { Input, type InputProps } from '@frontend/components';

import type { SupportFormFieldName } from '../types';
import { SupportFormControl } from './SupportFormControl';
import type { SupportFormControlProps } from './SupportFormControl';
import { SupportFormField } from './SupportFormField';

export type SupportFormInputFieldProps<FieldName extends SupportFormFieldName> =
  Omit<SupportFormControlProps<FieldName>, 'fieldProps' | 'isRequired'> & {
    inputProps?: InputProps;
  };

export const SupportFormInputField = <FieldName extends SupportFormFieldName>({
  name,
  inputProps = {},
  ...restProps
}: SupportFormInputFieldProps<FieldName>) => {
  const { isRequired } = inputProps;

  return (
    <SupportFormField name={name}>
      {(fieldProps) => {
        const { field } = fieldProps;

        return (
          <SupportFormControl
            {...restProps}
            fieldProps={fieldProps}
            name={name}
            isRequired={isRequired}
          >
            <Input {...field} {...inputProps} />
          </SupportFormControl>
        );
      }}
    </SupportFormField>
  );
};
